import React from 'react';
import PropTypes from 'prop-types';
import FormGroup from 'components/forms/FormGroup';
import { fieldInputPropTypes, fieldMetaPropTypes } from 'redux-form/lib/propTypes';

const RenderSelect = ({ input, label, id, children, meta: { touched, error } }) => (
  <FormGroup
    labelClasses={label ? '' : 'sr-only'}
    labelText={label}
    forValue={id}
    formGroupClasses={touched && error ? 'has-error' : ''}
    helpBlockText={touched && error ? error : ''}
  >
    <select {...input} id={id} className="form-control">
      {children}
    </select>
  </FormGroup>
);

RenderSelect.defaultProps = {
  label: '',
};

RenderSelect.propTypes = {
  input: PropTypes.shape(fieldInputPropTypes).isRequired,
  label: PropTypes.string,
  id: PropTypes.string.isRequired,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  meta: PropTypes.shape(fieldMetaPropTypes).isRequired,
};

export default RenderSelect;
